import React from "react";
import { Modal, Button, Col, Row } from "react-bootstrap";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  TelegramIcon,
} from "react-share";
import { copyToClipboard } from "../../../Util/helper_functions";
import "../../user-pages/userpages.css";

const ShareModel = ({ show, onHide, shareUrl, id }) => {
  const deviceSize = { maxWidth: 1199 };
  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        centered
        // backdrop="true"
        // keyboard={true}
      >
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <Modal.Title>Share & Invite Your Friends</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="d-flex justify-content-around">
            {/* Copy Link Button */}
            <Col xs={1} sm={4} md={2} className="text-center mt-2">
              <Button
                variant="link"
                onClick={() => copyToClipboard(shareUrl)}
                style={{
                  padding: 0,
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: "#80808038",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                className="icon-responsive"
              >
                <i
                  className="mdi mdi-content-copy"
                  style={{
                    color: "black",
                    fontSize: "20px",
                    margin: 0,
                  }}
                />
              </Button>
              <p className="d-none d-md-block mt-1">Copy</p>
            </Col>

            {/* Facebook Share Button */}
            <Col xs={1} md={2} className="text-center mt-2">
              <FacebookShareButton
                url={shareUrl}
                quote="Check out this awesome content!"
              >
                <FacebookIcon size={40} round className="icon-responsive" />
              </FacebookShareButton>
              <p className="d-none d-md-block mt-1">Facebook</p>
            </Col>

            {/* Twitter Share Button */}
            <Col xs={1} md={2} className="text-center mt-2">
              <TwitterShareButton url={shareUrl} title="Check this out!">
                <TwitterIcon size={40} round className="icon-responsive" />
              </TwitterShareButton>
              <p className="d-none d-md-block mt-1">Twitter</p>
            </Col>

            {/* WhatsApp Share Button */}
            <Col xs={1} md={2} className="text-center mt-2">
              <WhatsappShareButton url={shareUrl} title="Check this out!">
                <WhatsappIcon size={40} round className="icon-responsive" />
              </WhatsappShareButton>
              <p className="d-none d-md-block mt-1">WhatsApp</p>
            </Col>

            {/* Telegram Share Button */}
            <Col xs={1} md={2} className="text-center mt-2">
              <TelegramShareButton url={shareUrl}>
                <TelegramIcon size={40} round className="icon-responsive" />
              </TelegramShareButton>
              <p className="d-none d-md-block mt-1">Telegram</p>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="py-0">
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ShareModel;
